import { ApolloLink } from '@apollo/client';
import { inflate } from 'graphql-deduplicator';

export const inflateLink = new ApolloLink((operation, forward) => forward(operation).map(inflate));
